import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const setIsPlanboardAvailableAction = (state: PlanboardState, action: PayloadAction<boolean>) => {
  state.isPlanboardAvailable = action.payload;
};
